/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchOperationsEventCreateRequest } from './MatchOperationsEventCreateRequest';
import {
    MatchOperationsEventCreateRequestFromJSON,
    MatchOperationsEventCreateRequestFromJSONTyped,
    MatchOperationsEventCreateRequestToJSON,
    MatchOperationsEventCreateRequestToJSONTyped,
} from './MatchOperationsEventCreateRequest';

/**
 * 
 * @export
 * @interface MatchOperationsEventBatchRequest
 */
export interface MatchOperationsEventBatchRequest {
    /**
     * 
     * @type {Array<MatchOperationsEventCreateRequest>}
     * @memberof MatchOperationsEventBatchRequest
     */
    events?: Array<MatchOperationsEventCreateRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof MatchOperationsEventBatchRequest
     */
    allowOutOfOrder?: boolean | null;
}

/**
 * Check if a given object implements the MatchOperationsEventBatchRequest interface.
 */
export function instanceOfMatchOperationsEventBatchRequest(value: object): value is MatchOperationsEventBatchRequest {
    return true;
}

export function MatchOperationsEventBatchRequestFromJSON(json: any): MatchOperationsEventBatchRequest {
    return MatchOperationsEventBatchRequestFromJSONTyped(json, false);
}

export function MatchOperationsEventBatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationsEventBatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'events': json['events'] == null ? undefined : ((json['events'] as Array<any>).map(MatchOperationsEventCreateRequestFromJSON)),
        'allowOutOfOrder': json['allowOutOfOrder'] == null ? undefined : json['allowOutOfOrder'],
    };
}

export function MatchOperationsEventBatchRequestToJSON(json: any): MatchOperationsEventBatchRequest {
    return MatchOperationsEventBatchRequestToJSONTyped(json, false);
}

export function MatchOperationsEventBatchRequestToJSONTyped(value?: MatchOperationsEventBatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'events': value['events'] == null ? undefined : ((value['events'] as Array<any>).map(MatchOperationsEventCreateRequestToJSON)),
        'allowOutOfOrder': value['allowOutOfOrder'],
    };
}

